// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Carousel_carouselContainer__4obvH","img":"Carousel_img__hu8l9"};